/* eslint-disable no-unused-vars */
/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getList({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(`course-timetables?${new URLSearchParams(param)}`)
        .then((response) => {
          commit("SET_LIST", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getReport({ commit }, param) {
    return new Promise((resolve, reject) => {
      //Tìm hiểu CRUD API, quy tắc đặt route cho nó chuẩn xíu
      axios
        .get(`course-timetables/reports?${new URLSearchParams(param)}`)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getDetail({ commit }, { id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`course-timetables/${id}?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getMergeTimetableDetail({ commit }, { id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`course-timetables/${id}?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_DATA_MERGE_TIMEABLE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  cloneMultiple({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("course-timetables/clone-multiple", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateMultiple({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("course-timetables/update-multiple", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  deleteMultiple({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("course-timetables/delete-multiple", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  checkin({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`course-timetables/${id}/checkin`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  mergeTimeable({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`course-timetables/${id}/merge`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  leave({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`course-timetables/${id}/leave`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  book({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`course-timetables/${id}/book`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  addContact({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`course-timetables/${id}/book-contact`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  cancelContact({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`course-timetables/${id}/cancel-contact`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateTimetable({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`timetables/${id}`, payload)
        .then((response) => {
          commit("UPDATE_TIMETABLE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateTimetableStatus({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`course-timetables/${id}/statuses`, payload)
        .then((response) => {
          commit("UPDATE_TIMETABLE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getReportSalary({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `course-timetables/salary-reports?${new URLSearchParams(param)}`,
          null,
          {
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchTeacherDailyReport({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get("reports/teacher-daily-schedule", { params: param })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },

  setSelecting({ commit }, data) {
    commit("SET_DETAIL", data);
  },

  updateTimetableToList({ commit }, data) {
    commit("UPDATE_TIMETABLE", data);
  },
};
